import { Tooltip } from "react-tooltip";
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ModeCommentOutlinedIcon from '@mui/icons-material/ModeCommentRounded';
import SendIcon from '@mui/icons-material/SendRounded';
import BookmarkIcon from '@mui/icons-material/Bookmark';

import React, { useContext, useState, forwardRef, useImperativeHandle } from 'react';
import { FormContext } from '../../../context/FormContext';
import FormField from '../../UI/FormField';
import ErrorText from '../../UI/ErrorText';
import { ArrowForward, KeyboardArrowDown } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";


function IntroStep() {

  const { formData, updateForm } = useContext(FormContext);

  const { navigate } = useNavigate();
  const [local, setLocal] = useState({
    followerCount: formData.followerCount ?? 0,
  });

  return (
    <>
      <div className="contents-main">
        <h1>How it works.</h1>
        <div>
          <p>
            We’ll ask you for a few numbers to calculate how much money you’ve made Instagram. Your invoice is created using four values:
          </p>
          <ul>
            <li>Content Revenue Value</li>
            <li>Doomscroll Time Value</li>
            <li>Creative Labour Value</li>
            <li>Wellbeing Damages Fee</li>
          </ul>


          <p>
            Our calculations are based on published data, research, and a few estimates. You can read more about them <a href="/about" target="_blank">here</a>.
          </p>
        </div>

      </div>
    </>


  );
}
export default IntroStep;